<script>

export default {
  name: 'wixconnect',
  props: ['wixtoken'],
  data: function () {
    return { token: this.wixtoken }
  },
  methods: {
    sendAuth: function (wixtoken) {
      const appID = '8c74cf5b-ca04-4820-afcd-826f52daf2f6'
      alert(window.location.href)
      const url = 'https://www.wix.com/app-oauth-installation/consent?token=' + wixtoken + '&appId=' + appID + '&redirectUrl=' + encodeURIComponent(window.location.origin + '/wixcallback')
      window.location = url
    }
  },
  mounted: function () {
    if (typeof this.wixtoken === 'undefined' || this.wixtoken === null || this.wixtoken.length === 0) {
      alert('token ' + this.wixtoken + ' is not recognized')
      return false
    }

    this.sendAuth(this.wixtoken)
  }
}
</script>
